import c from "react";
import { q as p } from "./index.CVakAlTX.js";
import f from "swr";
import { API_BASE_LANG as P, API_BASE_URL as y } from "../constants/requests/index.js";
import { u as I } from "./use-sitecore-context.C7g4vcbm.js";
import { f as i } from "./fetcher.CPHInLJD.js";
const S = "suggesttaxonomy", _ = `taxonomy/${S}`, L = ({
  searchQuery: s
} = {}) => {
  var r, a;
  const { sitecoreContext: o } = I(), t = (r = o == null ? void 0 : o.route) != null && r.itemId ? `{${(a = o == null ? void 0 : o.route) == null ? void 0 : a.itemId}}` : "", m = (o == null ? void 0 : o.language) ?? P, [e, n] = c.useState(s), u = {
    language: m,
    searchQuery: e,
    pageId: t
  }, g = p.stringify(u);
  return {
    ...f(
      `${y}${_}?${g}`,
      i
    ),
    setTaxonomyParameter: n
  };
};
export {
  L as u
};
